import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function Veho(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_144_33)"
  }, React.createElement(Path, {
    d: "M23.497 11.18L18.1 4.86C17.72 4.402 17.137 4 16.466 4H3.252c-1.167 0-1.78.775-1.896 1.895L.014 19.105C-.132 20.11.889 21 1.939 21H7L8.29 9.973c.03-.345.088-.546.292-.718.204-.172.438-.258.73-.258.203 0 .35.028.495.114l6.505 2.556c.38.144.642.488.642.89s-.262.747-.642.89l-5.28 2.298c-.729.43-1.111.747-1.344 1.723L9.25 21h6.341c.876 0 1.196-.43 1.634-.861l6.272-6.318c.67-.775.67-1.867 0-2.642z"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_144_33"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default Veho;